import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "modal is-active" }
const _hoisted_2 = { class: "modal-card" }
const _hoisted_3 = { class: "modal-card-head" }
const _hoisted_4 = { class: "modal-card-body" }
const _hoisted_5 = { class: "modal-card-foot" }


export default /*@__PURE__*/_defineComponent({
  __name: 'Modal',
  emits: ["cancel"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "modal-background",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('cancel')))
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _renderSlot(_ctx.$slots, "title"),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('cancel'))),
          class: "delete",
          "aria-label": "close"
        })
      ]),
      _createElementVNode("section", _hoisted_4, [
        _renderSlot(_ctx.$slots, "body")
      ]),
      _createElementVNode("footer", _hoisted_5, [
        _renderSlot(_ctx.$slots, "buttons")
      ])
    ])
  ]))
}
}

})